import { SetUniqueWidgetRefreshContext } from 'App';
import Cookies from 'js-cookie';
import React, { useContext, useEffect, useState } from 'react';
import routeOffsetMinutes from 'utils/routeOffsetMinutes.js';
import { WidgetVisibilityContext } from './WidgetVisibilityContext';

const WidgetTimeUpdate = ({
  realtime = false,
  updateIntervalBasis = 360,
  route = null,
  dataUpdateOnly = false,
  addMargin = false,
}) => {
  const updateOffsetMinutes = routeOffsetMinutes[route] || 3;

  const setUwf = useContext(SetUniqueWidgetRefreshContext);
  const { pollingActive = true } = useContext(WidgetVisibilityContext);
  const [nextUpdate, setNextUpdate] = useState(
    new Date().toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true,
    }),
  );
  const [currTime, setCurrTime] = useState(
    new Date().toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true,
    }),
  );
  const UPDATE_MINUTES = 3; //3; //interval to check for updates

  useEffect(() => {
    if (!pollingActive) {
      return undefined;
    }

    const getUpdateTime = () => {
      const currentTimeLabel = new Date().toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true,
      });
      setCurrTime(currentTimeLabel);
      const newUpdateTime = calculateNextTime();
      setNextUpdate(newUpdateTime);

      if (route !== null && typeof setUwf === 'function' && newUpdateTime) {
        const location = `${Cookies.get('city')}-${Cookies.get('state')}`;
        const uniqueKey = `${location}-${route}`;
        const refreshValue = String(newUpdateTime);

        setUwf((prev) => {
          const previousValue = prev?.[uniqueKey];
          if (previousValue === refreshValue) {
            return prev;
          }

          return {
            ...(prev || {}),
            [uniqueKey]: refreshValue,
          };
        });
      }
    };

    getUpdateTime();
    const interval = setInterval(
      () => {
        getUpdateTime();
      },
      1000 * 60 * UPDATE_MINUTES,
    ); // every 5 minutes, calculate the next update time
    return () => clearInterval(interval);
  }, [pollingActive, route, realtime, updateIntervalBasis, updateOffsetMinutes, setUwf]);

  const calculateNextTime = () => {
    if (!route) {
      return;
    }
    if (realtime) {
      const now = new Date();
      now.setMinutes(now.getMinutes() + 1); // Add one minute
      now.setSeconds(0); // Set seconds to 0
      now.setMilliseconds(0); // Set milliseconds to 0
      return now.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true,
      });
    }
    const now = new Date();
    let currentMinutes = now.getUTCHours() * 60 + now.getUTCMinutes() - 300;

    let lastInterval = Math.floor(currentMinutes / updateIntervalBasis) * updateIntervalBasis;
    let nextUpdateMinutes = lastInterval + updateOffsetMinutes;

    if (currentMinutes >= nextUpdateMinutes) {
      nextUpdateMinutes += updateIntervalBasis;
    }

    const nextUpdate = new Date(now.getTime() + (nextUpdateMinutes - currentMinutes) * 60 * 1000);
    nextUpdate.setSeconds(0); // Set seconds to 0
    nextUpdate.setMilliseconds(0); // Set milliseconds to 0

    return nextUpdate.toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true,
    });
  };

  return (
    <div
      className="border-bottom border-secondary border-1"
      style={{ marginBottom: addMargin ? 10 : 0 }}
    >
      <div className="d-flex flex-column align-items-center gap-sm-3 flex-sm-row">
        <div
          className="text-truncate"
          style={{ fontSize: 'var(--widget-subtext-font-size, 1rem)' }}
        >
          {currTime.toLocaleString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: true,
          })}
        </div>
        <div
          className="text-truncate"
          style={{ fontSize: 'var(--widget-subtext-font-size, 1rem)' }}
        >
          Next update: {nextUpdate}
        </div>
      </div>
    </div>
  );
};

export default WidgetTimeUpdate;
